<template>
  <NavLink href="/" class="flex ">
    <div>
      <img src="/images/fleet-risk-review-h40-blue.png" alt="Fleet Risk Review Logo" />
    </div>
    <div>
      <h3 class="text-2xl font-display text-brand-blue-400 ml-2 mt-1 uppercase tracking-tighter">
        Fleet Risk Review
      </h3>
    </div>
  </NavLink>
</template>

<script>
import NavLink from "./NavLink.vue";

export default {
  components: {
    NavLink,
  }
}
</script>